import React from 'react';

import { Box } from '@components/Restyle';
import { Skeleton } from '@components/shared/Skeleton';
import theme from '@themes/theme';
import { isMobileBrowser } from '@utils/mobileDeepLink';

/**
 * My Account profile card placeholder — mirrors the real `ProfileCard`'s
 * bordered card shell (TA-10277): avatar circle + 2 name text lines, then
 * a Location / Phone Number / Email row (label + value) each, and a Skills
 * row (label + 2 tag-shaped placeholders). Drops the fixed width on
 * mobile-browser, matching `ProfileCard.web.tsx`'s own
 * `isMobile ? undefined : 560` — this skeleton is also rendered by
 * `MyProfile.web.tsx` (the mobile-browser screen).
 */
export const ProfileCardSkeleton: React.FC<{ testID?: string }> = ({
  testID = 'profile-card-skeleton',
}) => {
  const isMobile = isMobileBrowser();

  return (
    <Box
      testID={testID}
      width={isMobile ? undefined : 560}
      borderWidth={1}
      borderColor='grey02'
      padding='m'>
      <Box flexDirection='row' alignItems='center'>
        <Skeleton
          variant='circle'
          width={48}
          height={48}
          style={{ marginRight: theme.spacing.s }}
        />
        <Box style={{ gap: theme.spacing.xxs }}>
          <Skeleton variant='text' width={120} />
          <Skeleton variant='text' width={80} height={10} />
        </Box>
      </Box>

      <Box
        flexDirection='row'
        alignItems='center'
        marginTop='m'
        justifyContent='space-between'>
        <Skeleton variant='text' width={80} />
        <Skeleton variant='text' width={100} />
      </Box>

      <Box
        flexDirection='row'
        alignItems='center'
        marginTop='m'
        justifyContent='space-between'>
        <Skeleton variant='text' width={110} />
        <Skeleton variant='text' width={130} />
      </Box>

      <Box
        flexDirection='row'
        alignItems='center'
        marginTop='m'
        justifyContent='space-between'>
        <Skeleton variant='text' width={60} />
        <Skeleton variant='text' width={150} />
      </Box>

      <Box marginTop='m' flexDirection='row' alignItems='center'>
        <Skeleton
          variant='text'
          width={50}
          style={{ marginRight: theme.spacing.xs }}
        />
        <Skeleton
          variant='rect'
          width={70}
          height={20}
          borderRadius='xxs'
          style={{ marginRight: theme.spacing.xxs }}
        />
        <Skeleton variant='rect' width={90} height={20} borderRadius='xxs' />
      </Box>
    </Box>
  );
};
